import * as React from 'react';

export function useScreenWakeLock() {
  React.useEffect(() => {
    if (!('wakeLock' in navigator)) {
      return;
    }

    let cancelled = false;
    let requestPending = false;
    let wakeLock: WakeLockSentinel | undefined;

    const requestWakeLock = async () => {
      if (cancelled || requestPending || wakeLock || document.visibilityState !== 'visible') {
        return;
      }

      requestPending = true;
      try {
        const nextWakeLock = await navigator.wakeLock.request('screen');
        if (cancelled || document.visibilityState !== 'visible') {
          await nextWakeLock.release();
          return;
        }
        wakeLock = nextWakeLock;
        nextWakeLock.addEventListener(
          'release',
          () => {
            if (wakeLock === nextWakeLock) {
              wakeLock = undefined;
            }
          },
          { once: true },
        );
      } catch (error) {
        console.warn('Could not acquire screen wake lock', error);
      } finally {
        requestPending = false;
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        void requestWakeLock();
      } else if (wakeLock) {
        void wakeLock.release();
        wakeLock = undefined;
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    void requestWakeLock();

    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (wakeLock) {
        void wakeLock.release();
        wakeLock = undefined;
      }
    };
  }, []);
}
